var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _rect8, _rect9, _rect10, _rect11, _rect12, _path3, _rect13, _rect14, _rect15, _rect16, _rect17, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 170,
    viewBox: "0 0 120 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16.7213,
    width: 120,
    height: 153.279,
    rx: 2,
    fill: "#FA6C51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.58142,
    y: 22.295,
    width: 108.837,
    height: 142.131,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.05 4.96644C51.1831 6.74429 49.6219 8.36065 47.6418 8.36065H30.6976C28.6426 8.36065 26.9767 10.0243 26.9767 12.0765V22.2951C26.9767 24.3473 28.6426 26.0109 30.6976 26.0109H89.3023C91.3573 26.0109 93.0232 24.3473 93.0232 22.2951V12.0765C93.0232 10.0243 91.3573 8.36065 89.3023 8.36065H72.3581C70.378 8.36065 68.8168 6.74429 67.9499 4.96644C66.5162 2.02617 63.495 0 59.9999 0C56.5049 0 53.4837 2.02617 52.05 4.96644ZM59.9999 14.8634C62.8256 14.8634 65.1162 12.5759 65.1162 9.7541C65.1162 6.93232 62.8256 4.64481 59.9999 4.64481C57.1743 4.64481 54.8837 6.93232 54.8837 9.7541C54.8837 12.5759 57.1743 14.8634 59.9999 14.8634Z",
    fill: "#6C3126"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5116,
    y: 39.9453,
    width: 48.3721,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 47.377,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 54.8087,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 62.2404,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7441,
    y: 41.8743,
    width: 20.3256,
    height: 20.2951,
    rx: 3,
    stroke: "#D6D6D6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3953 52.0218L26.0464 56.6666L35.3488 47.377",
    stroke: "#6CBF84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5116,
    y: 81.7487,
    width: 48.3721,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 89.1803,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 96.6121,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 104.044,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7441,
    y: 83.6776,
    width: 20.3256,
    height: 20.2951,
    rx: 3,
    stroke: "#D6D6D6",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3953 93.8251L26.0464 98.4699L35.3488 89.1803",
    stroke: "#6CBF84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5116,
    y: 122.623,
    width: 48.3721,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 130.055,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 137.486,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5115,
    y: 144.918,
    width: 56.7442,
    height: 1.85792,
    rx: 0.928962,
    fill: "#D6D6D6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7441,
    y: 124.552,
    width: 20.3256,
    height: 20.2951,
    rx: 3,
    stroke: "#D6D6D6",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3953 134.699L26.0464 139.344L35.3488 130.055",
    stroke: "#6CBF84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.19cd9a5ddecad2fa22c4a0af457d6cb8.svg";
export { ForwardRef as ReactComponent };